<template>
    <div id="help">
        
        <div class="container">
            <div class="row">
                <div class="twelve columns">
                    <h3>Crear Usuario</h3>
                   <img src="../assets/img2/HELP1.png" class="responsive">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="twelve columns">
                    <h6>Completar los datos. Tener en cuenta que los campos con asterisco (*) deben completarse obligatoriamente</h6>
                   <img src="../assets/img2/HELP2.png" class="responsive">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="twelve columns">
                    <h6>Completar el campo "No soy robot" y luego clic en Crear Usuario</h6>
                   <img src="../assets/img2/HELP3.png" class="responsive">
                </div>
            </div>
            <div class="row">
                <div class="twelve columns">
                    <h6>Pantalla de confirmación. Tener en cuenta que debe revisar la bandeja de entrada del correo electrónico para confirmar la cuenta. Si no hace esto, no podrá iniciar sesión. El link de confirmación tiene una validez por 60 minutos.
                    </h6>
                   <img src="../assets/img2/HELP4.png" class="responsive">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="twelve columns">
                    <h6>En el correo de confirmación que le llego al mail que registro en la web, debe hacer clic en el link para confirmar la cuenta.
                    </h6>
                   <img src="../assets/img2/HELP7.png" class="responsive">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="twelve columns">
                    <h6>Luego de hacer clic en el link, aparecerá una ventana para ingresar el usuario y contraseña que ingreso en la pantalla de Crear Usuario
                    </h6>
                   <img src="../assets/img2/HELP8.png" class="responsive">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="twelve columns">
                    <h6>En este caso, luego de ingresar usuario y contraseña, aparece esta ventana, en la cual no se pudo confirmar el usuario, ya que se hizo dicha confirmación pasado los 60 minutos de valides del link. No se preocupe, el sistema le enviará automáticamente un nuevo correo con un link valido.
                    </h6>
                   <img src="../assets/img2/HELP9.png" class="responsive">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="twelve columns">
                    <h6>Revisando nuevamente el correo, verá que hay un nuevo correo, haga clic en el link.
                    </h6>
                   <img src="../assets/img2/HELP10.png" class="responsive">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="twelve columns">
                    <h6>Como el link es válido, aparece la pantalla de confirmación de la cuenta. Ahora esta habilitado para sacar turno.
                    </h6>
                   <img src="../assets/img2/HELP11.png" class="responsive">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="twelve columns">
                    <h6>Si no encuentra el correo de validación en la bandeja de entrada, o necesita que se reenvíe el mail, puede hacerlo desde esta ventana
                    </h6>
                   <img src="../assets/img2/HELP5.png" class="responsive">
                   <img src="../assets/img2/HELP6.png" class="responsive">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="twelve columns">
                    <h3>Sacar Turno
                    </h3>
                    <h6>Iniciar sesión
                    </h6>
                   <img src="../assets/img2/HELP12.png" class="responsive">
                </div>
            </div>
            <br>
            <div class="row">
                <div class="twelve columns">
                    <h6>Al iniciar sesión, se activa el menú Turnos. En esta sección, deberá seleccionar un profesional de la lista desplegable.
                    </h6>
                   <img src="../assets/img2/HELP13.png" class="responsive">
                   <img src="../assets/img2/HELP14.png" class="responsive">
                </div>
            </div>
            <br>
            
            <div class="row">
                <div class="twelve columns">
                    <h6>Cuando seleccione un médico, automáticamente aparece una lista con los turnos disponibles para ese profesional. Haga clic en el horario que desee, y confirme el turno.
                    </h6>
                   <img src="../assets/img2/HELP15.png" class="responsive">
                   <img src="../assets/img2/HELP16.png" class="responsive">
                </div>
            </div>
             <br>
            <div class="row">
                <div class="twelve columns">
                     <h6>Si todo salió bien, se mostrará la pantalla de confirmación, con los datos del turno y dirección del centro médico.
                    </h6>
                   <img src="../assets/img2/HELP17.png" class="responsive">
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>

    export default {
        name: 'help',
        data: function() {
            return {
            }
        },
        methods: {
            autoResize(){
                let id='iframe1'
                
                var newheight;
                var newwidth;

                if(document.getElementById){
                    newheight=document.getElementById(id).contentWindow.document.body.scrollHeight;
                    newwidth=document.getElementById(id).contentWindow.document.body.scrollWidth;
                }

                document.getElementById(id).height= (newheight) + "px";
                document.getElementById(id).width= (newwidth) + "px";
            }

        }
    }
    
</script>

<style>
    .responsive {
    width: 100%;
    height: auto;
    }
</style>